import type { TextCallOut } from '../../../../../types/MiniSiteContents';
import ContentWrapper from '../../../common/ContentWrapper';
import Markdown from '../../../common/Markdown/Markdown';

type Props = {
  miniSiteContent: TextCallOut;
};

const MiniSiteTextCallOut = ({ miniSiteContent }: Props) => {
  const { contentTitle, title, subTitle, descriptionFirst, descriptionSecond } = miniSiteContent;

  return (
    <ContentWrapper className="w-full">
      {contentTitle && <p className="pb-6 text-title3 font-bold">{contentTitle}</p>}
      <div className="flex flex-col rounded-lg bg-white p-5 lg:flex-row">
        <div className="flex w-full flex-col items-center gap-2 p-5 lg:w-1/2 lg:items-start">
          <p className="text-large font-bold">{title}</p>
          <p className="text-small">{subTitle}</p>
        </div>
        <div className="flex w-full flex-col gap-2 px-1 py-5 sm:px-5 lg:w-1/2">
          <p className="font-bold">{descriptionFirst}</p>
          <Markdown className="text-small">{descriptionSecond}</Markdown>
        </div>
      </div>
    </ContentWrapper>
  );
};

export default MiniSiteTextCallOut;
